import APIContext from 'contexts/base/APIContext'

export default class StationsContext extends APIContext{
  static contextName = 'stations'
}
